import { Button, SidebarMenuItem } from '@duck/ui'
import { useAuth } from '@/hooks/useAuth'

const loginsEnv = localStorage.getItem('quickLogins')

export const QuickLoginButtons = () => {
    const { signInWithEmail, isSigningInWithEmail, signOut, isAuthenticated } = useAuth()

    if (!loginsEnv) {
        return null
    }

    const entries = loginsEnv
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .map((item) => {
            const match = item.match(/^\[([^\]]+)\]\(([^)]+)\)$/)
            if (!match) return null
            const [, label, credentials] = match
            const [email, explicitPassword] = credentials.split('|')
            if (!email) return null
            return { label, email, password: explicitPassword || email }
        })
        .filter((entry): entry is { label: string; email: string; password: string } => Boolean(entry))

    if (entries.length === 0) {
        return null
    }

    const handleQuickLogin = async (email: string, password: string) => {
        if (isAuthenticated) {
            await signOut()
        }
        void signInWithEmail({
            email,
            password,
        })
    }

    return (
        <SidebarMenuItem>
            <div className="px-2 mt-2 flex flex-wrap gap-2">
                {entries.map(({ label, email, password }) => (
                    <Button
                        key={email}
                        size="xs"
                        variant="outline"
                        onClick={() => handleQuickLogin(email, password)}
                        disabled={isSigningInWithEmail}
                    >
                        {label}
                    </Button>
                ))}
            </div>
        </SidebarMenuItem>
    )
}
